import { connect } from 'react-redux';

import type { UserContext } from '@zola-helpers/client/dist/es/@types';

import { getUserContext } from 'selectors/user';

import NavPrimary from './NavPrimary';
import { RootState } from '../../../reducers';

type NavPrimaryMapStateProps = {
  userContext: UserContext | undefined;
};

const mapStateToProps = (state: RootState): NavPrimaryMapStateProps => ({
  userContext: getUserContext(state),
});

const ConnectedNavPrimary = connect(mapStateToProps, null)(NavPrimary);

export default ConnectedNavPrimary;
